import './polyfills/polyfills';
import Navigation from './components/navigation';
import Carousel from './components/carousel';
import Alpine from 'alpinejs';
import './modules/lightbox';
import { AjaxRequest, AjaxMethod, AjaxResponseType } from './modules/ajax';
import { Lightbox, LightboxType } from './modules/lightbox';
import './extensions/object';
import Maps from './components/maps';
import PrivacyPolicy from './components/privacypolicy';
import Forms from './components/forms';
import { Site } from './site';
import AnimatedCounter from './components/animatedcounter';
window.Alpine = Alpine;
Alpine.start();
class Main {
    constructor() {
        var self = this;
        //new SVG();
        new Navigation();
        new Carousel();
        new Maps();
        new PrivacyPolicy();
        new Forms();
        new AnimatedCounter();
        this.lightboxes();
        this.embed();
        this.ajaxPaging();
        if (window["AOS"])
            window["AOS"].init();
        this.Site = new Site();
        self.Footer = document.getElementById("footer");
        self.Header = document.getElementById("header");
        self.Main = document.getElementById("wrapper");
        self.sizeCheck();
        window.addEventListener("scroll", function () {
            if (window.pageYOffset > 20) {
                document.body.classList.add("is-scrolled");
            }
            else {
                document.body.classList.remove("is-scrolled");
            }
        });
        document.querySelectorAll('table').forEach((table) => {
            var container = document.createElement('div');
            container.className = "table-responsive";
            table.parentNode.insertBefore(container, table);
            container.appendChild(table);
        });
        document.addEventListener("DOMContentLoaded", function (event) {
            self.wrapText("pulsen group", "nowrap");
        });
    }
    sizeCheck() {
        let self = this;
        document.addEventListener("DOMContentLoaded", function (event) {
            self.checkSize();
        });
        window.onresize = () => {
            self.checkSize();
        };
        Promise.all(Array.from(document.images)
            .filter(img => !img.complete)
            .map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
            self.checkSize();
        });
        /*setInterval(() => {
            self.checkSize();
        }, 10);*/
        var observer = new MutationObserver(function () {
            self.checkSize();
        });
    }
    checkSize() {
        if (this.Footer) {
            let footerSize = this.Footer.getBoundingClientRect();
            document.body.style.setProperty('--footer-height', Math.round(footerSize.height) + "px");
            document.body.style.setProperty('--footer-width', Math.round(footerSize.width) + "px");
            //this.Footer.classList.toggle("fixed-bottom", document.body.clientHeight <= window.innerHeight);
        }
        if (this.Header) {
            let headerSize = this.Header.getBoundingClientRect();
            document.body.style.setProperty('--header-height', Math.round(headerSize.height) + "px");
            document.body.style.setProperty('--header-width', Math.round(headerSize.width) + "px");
        }
        document.body.classList.toggle("floating-footer", document.body.clientHeight <= window.innerHeight);
    }
    lightboxes() {
        let anchors = document.querySelectorAll(".lightbox");
        anchors.forEach(item => {
            item.lightBox({ disableScrollOnOpen: true });
        });
    }
    embed() {
        var embeds = document.querySelectorAll(".embed");
        if (embeds.length > 0) {
            embeds.forEach(embed => {
                let data = JSON.parse(embed.getAttribute("data-options"));
                let holder = embed.querySelector(".holder");
                let anchor = embed.querySelector("a");
                if (anchor != null) {
                    anchor.addEventListener("click", (e) => {
                        e.preventDefault();
                        open(data, holder, anchor);
                    });
                }
                else {
                    open(data, holder, anchor);
                }
            });
        }
        function open(data, holder, anchor) {
            if (data.lightbox) {
                let url = "/umbraco/Bjornmamman/Utilities/Embed?" + Object.param({ url: data.url, width: data.width, height: data.height });
                let lightbox = new Lightbox({ disableScrollOnOpen: false, width: data.width, height: data.width, type: LightboxType.AJAX, href: url });
                lightbox.open();
            }
            else {
                let ajax = new AjaxRequest();
                ajax.Send(AjaxMethod.GET, "/umbraco/Bjornmamman/Utilities/Embed", { url: data.url, width: data.width, height: data.height }, { ResponseType: AjaxResponseType.TEXT }).then(results => {
                    holder.innerHTML = results.data;
                    holder.classList.remove("hidden");
                    holder.classList.add("open");
                    anchor.remove();
                }, error => {
                });
            }
        }
    }
    inViewport(element, options = { offset: { top: 0, right: 0, bottom: 0, left: 0 }, threshold: 0 }) {
        const { top, right, bottom, left, width, height } = element.getBoundingClientRect();
        const intersection = {
            t: bottom,
            r: window.innerWidth - left,
            b: window.innerHeight - top,
            l: right
        };
        const threshold = {
            x: options.threshold * width,
            y: options.threshold * height
        };
        return intersection.t > (options.offset.top + threshold.y)
            && intersection.r > (options.offset.right + threshold.x)
            && intersection.b > (options.offset.bottom + threshold.y)
            && intersection.l > (options.offset.left + threshold.x);
    }
    ajaxPaging() {
        let buttons = document.querySelectorAll(".ajax-paging");
        if (buttons.length > 0) {
            buttons.forEach((button, key) => {
                let parameters = getParameters(button);
                if (parameters.page >= parameters.pages) {
                    button.remove();
                }
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    load(e.target);
                });
            });
        }
        function getParameters(button) {
            let data = button.getData();
            return {
                url: button.getAttribute("href"),
                target: data.target,
                page: parseInt(data.page),
                pages: parseInt(data.pages)
            };
        }
        function load(button) {
            button.setAttribute("disabled", "disabled");
            let parameters = getParameters(button);
            let ajax = new AjaxRequest();
            ajax.Send(AjaxMethod.GET, parameters.url, { page: parameters.page + 1 }).then(results => {
                let holder = document.querySelector(parameters.target);
                holder.innerHTML += results.data;
                if (parameters.page + 1 >= parameters.pages) {
                    button.remove();
                }
                else {
                    button.setData("index", parameters.page + 1);
                }
                button.removeAttribute("disabled");
            }, error => {
                button.removeAttribute("disabled");
            });
        }
    }
    wrapText(search, tag) {
        var pos = window.scrollY;
        if (window.find) {
            while (window.find(search)) {
                var selection = window.getSelection();
                var text = selection.toString();
                var rng = selection.getRangeAt(0);
                if (rng.commonAncestorContainer.parentElement.className.indexOf("btn") == -1 &&
                    rng.commonAncestorContainer.parentElement.tagName.toLowerCase() != tag) {
                    selection.deleteFromDocument();
                    rng.collapse(false);
                    var node = document.createElement(tag);
                    node.appendChild(document.createTextNode(text));
                    rng.insertNode(node);
                }
            }
            window.getSelection().removeAllRanges();
        }
        window.scrollTo(0, pos);
    }
}
window["Main"] = new Main();
